import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteEnvironment } from "./api";
import { adminEnvironmentKeys } from "./queries";

export function useDeleteEnvironmentMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteEnvironment,
    onSuccess: async (_data, environmentId) => {
      queryClient.removeQueries({
        queryKey: adminEnvironmentKeys.adminDetail(environmentId),
      });
      await queryClient.invalidateQueries({
        queryKey: adminEnvironmentKeys.all,
      });
    },
  });
}
